import React from "react"
import { useDispatch } from "react-redux"
import { hideAllStatuses, showAllStatuses } from "reduxSlices/surveyRecipientTableSlice"
import MassSelection from "shared/MassSelection"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import DeliveryStatusList from "./DeliveryStatusList"

const DeliveryStatusFilter = () => {
  const dispatch = useDispatch()

  return (
    <SidebarCollapsibleContent title="Filter By Delivery Status">
      <div className="flex flex-col gap-2">
        <MassSelection
          deselectAll={() => dispatch(hideAllStatuses())}
          selectAll={() => dispatch(showAllStatuses())}
        />
        <DeliveryStatusList className="mb-4" />
      </div>
    </SidebarCollapsibleContent>
  )
}

export default DeliveryStatusFilter
